import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface Props {
  callLabel: string
  variant: 'contract' | 'details'
  onWhatsApp?: () => void
  onTelegram?: () => void
  onCall?: () => void
  showWhatsApp?: boolean
  showTelegram?: boolean
  showCall?: boolean
}

export const ManagerContacts: FC<Props> = ({
  callLabel,
  variant,
  onWhatsApp,
  onTelegram,
  onCall,
  showWhatsApp = true,
  showTelegram = true,
  showCall = true,
}) => {
  if (!showWhatsApp && !showTelegram && !showCall) return null

  return (
    <div className={clsx(s.contacts, s[variant])}>
      {(showWhatsApp || showTelegram) && (
        <div className={s.row}>
          {showWhatsApp && (
            <Button
              variant={variant === 'details' ? 'transparent' : 'yellow'}
              className={clsx(s.contact, s.whatsapp, 'semi-bold-14')}
              borderRadius="sm"
              onClick={onWhatsApp}
            >
              <AppIcon
                id={AllIcons.WHATSAPP}
                color="#fff"
                width={14}
                height={14}
              />
              WhatsApp
            </Button>
          )}
          {showTelegram && (
            <Button
              variant={variant === 'details' ? 'transparent' : 'yellow'}
              className={clsx(s.contact, s.telegram, 'semi-bold-14')}
              borderRadius="sm"
              onClick={onTelegram}
            >
              <AppIcon
                id={AllIcons.TELEGRAM}
                width={16}
                height={14}
              />
              Telegram
            </Button>
          )}
        </div>
      )}
      {showCall && (
        <Button
          variant={variant === 'details' ? 'transparent' : 'yellow'}
          className={clsx(s.contact, s.phone, 'semi-bold-14')}
          borderRadius="sm"
          onClick={onCall}
        >
          {callLabel}
        </Button>
      )}
    </div>
  )
}
